import Keycloak, { KeycloakLogoutOptions } from 'keycloak-js';

export const KEYCLOAK_TOKEN_UPDATED = 'updated';
export const KEYCLOAK_TOKEN_UPDATE_FAILED = 'failed';
export const KEYCLOAK_TOKEN_VALID = 'valid';

const keycloak = new Keycloak('/config/keycloak.json');

const initKeycloak = (onAuthenticatedCallback: () => void) => {
  keycloak
    .init({
      onLoad: 'check-sso',
    })
    .then(() => {
      onAuthenticatedCallback();
    })
    .catch(console.trace);
};

const login = keycloak.login;

const logout = (options?: KeycloakLogoutOptions) => keycloak.logout(options);

const getToken = () => keycloak.token;

const isLoggedIn = () => !!keycloak.token;

const updateToken = (minValidity = 5) =>
  keycloak
    .updateToken(minValidity)
    .then((refreshed) => (refreshed ? KEYCLOAK_TOKEN_UPDATED : KEYCLOAK_TOKEN_VALID))
    .catch((error) => {
      console.error('Failed to refresh keycloak token', error);
      return KEYCLOAK_TOKEN_UPDATE_FAILED;
    });

// For a token the server has already rejected: -1 skips keycloak's own expiry check.
// Parallel calls wait for the refresh request that is already in flight.
const forceUpdateToken = () => updateToken(-1);

const AuthService = {
  initKeycloak,
  login,
  logout,
  isLoggedIn,
  getToken,
  updateToken,
  forceUpdateToken,
  keycloak,
};

export default AuthService;
